module.exports = __webpack_public_path__ + "assets/img/title-68a713d5.png";